import FacePile from 'components/FacePile'
import InfiniteList from 'components/InfiniteList'
import StyledTooltip from 'components/Tooltip/Tooltip'
import ModalTrigger from 'components/common/ModalTrigger'
import BaseModal from 'components/modals/BaseModal'
import { ThreadQueryResult } from 'graphql/generated'
import useThreadCollaborators from './useThreadCollaborators'
import UserListItem from 'components/profiles/UserListItem'
import { Chip, Typography } from 'components/common'

const CollaboratorsModal: React.FC<{
  thread: Pick<
    ThreadQueryResult['thread'],
    'id' | 'collaborators' | 'collaboratorsCount' | 'user'
  >
}> = ({ thread }) => {
  const { collaborators, loadMoreCollaborators, loading, loadingMore } =
    useThreadCollaborators(thread.id)

  return (
    <ModalTrigger
      trigger={show => (
        <StyledTooltip title="Thread Collaborators">
          <div className="cursor-pointer" onClick={show}>
            <FacePile
              profiles={thread.collaborators.edges.map(edge => edge.node)}
              size={8}
              totalProfiles={thread.collaboratorsCount}
              spacing="sm:space-x-[-6px]"
            />
          </div>
        </StyledTooltip>
      )}
    >
      <BaseModal classNames="sm:max-w-2xl" disableBackdropClick>
        <div className="flex-1 flex flex-col p-4 space-y-2 overflow-hidden">
          <Typography size="heading">Collaborators</Typography>
          <div className="flex-1 overflow-auto">
            <InfiniteList
              className="space-y-2"
              items={collaborators}
              loadMore={loadMoreCollaborators}
              loading={loading}
              loadingMore={loadingMore}
              renderItem={user => (
                <div
                  className="hover:bg-gray-50 p-2 rounded-md border border-gray-200"
                  key={user.id}
                >
                  <UserListItem profile={user}>
                    {thread.user.id === user.id && (
                      <Chip size="sm" fill="darkOrange">
                        Author
                      </Chip>
                    )}
                  </UserListItem>
                </div>
              )}
            />
          </div>
        </div>
      </BaseModal>
    </ModalTrigger>
  )
}
export default CollaboratorsModal
